var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("菜单管理")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "menuBtn" },
      [
        _c("el-tree", {
          staticClass: "el-menu-vertical-demo",
          attrs: {
            data: _vm.tableData,
            props: _vm.defaultProps,
            "default-expand-all": true,
            "highlight-current": true,
          },
          on: { "node-click": _vm.handleNodeClick },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "manage" },
      [
        _c(
          "div",
          { staticClass: "btn" },
          [
            _vm.parArray.indexOf("addyimenu") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.oneLevelMenu },
                  },
                  [_vm._v("添加一级菜单")]
                )
              : _vm._e(),
            _vm.parArray.indexOf("addxia") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.lowerLevel },
                  },
                  [_vm._v("添加下级菜单")]
                )
              : _vm._e(),
            _vm.parArray.indexOf("menudel") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "danger" },
                    on: { click: _vm.delectData },
                  },
                  [_vm._v("删除菜单")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-form",
          {
            ref: "ruleForm",
            staticClass: "elForm",
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.rules,
              "label-width": "100px",
            },
          },
          [
            _vm.if_father
              ? _c(
                  "el-form-item",
                  { attrs: { label: "上级菜单", prop: "father_name" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.ruleForm.father_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "father_name", $$v)
                        },
                        expression: "ruleForm.father_name",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              { attrs: { label: "菜单名称", prop: "name" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.ruleForm.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "name", $$v)
                    },
                    expression: "ruleForm.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "菜单链接", prop: "link" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.ruleForm.link,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "link", $$v)
                    },
                    expression: "ruleForm.link",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "菜单编码", prop: "code" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.ruleForm.code,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "code", $$v)
                    },
                    expression: "ruleForm.code",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "菜单排序", prop: "sortNo" } },
              [
                _c("el-input", {
                  staticStyle: { width: "150px" },
                  attrs: { type: "number" },
                  model: {
                    value: _vm.ruleForm.sortNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "sortNo", $$v)
                    },
                    expression: "ruleForm.sortNo",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "菜单类型", prop: "menuType" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { disabled: "", placeholder: "请选择菜单类型" },
                    model: {
                      value: _vm.ruleForm.menuType,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "menuType", $$v)
                      },
                      expression: "ruleForm.menuType",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "菜单", value: "1" } }),
                    _c("el-option", { attrs: { label: "按钮", value: "2" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "系统类型", prop: "systemType" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择系统类型" },
                    model: {
                      value: _vm.ruleForm.systemType,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "systemType", $$v)
                      },
                      expression: "ruleForm.systemType",
                    },
                  },
                  _vm._l(_vm.systemlist, function (items) {
                    return _c("el-option", {
                      key: items.dictId,
                      attrs: { label: items.dictName, value: items.dictId },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "菜单图标", prop: "icon" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.ruleForm.icon,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "icon", $$v)
                    },
                    expression: "ruleForm.icon",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "权限标识", prop: "identification" } },
              [
                _c("el-input", {
                  model: {
                    value: _vm.ruleForm.identification,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "identification", $$v)
                    },
                    expression: "ruleForm.identification",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "菜单备注", prop: "desc" } },
              [
                _c("el-input", {
                  attrs: { type: "textarea" },
                  model: {
                    value: _vm.ruleForm.desc,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "desc", $$v)
                    },
                    expression: "ruleForm.desc",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _vm.parArray.indexOf("ljcj") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("立即创建")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }